import { useQuery } from '@tanstack/react-query';
import { getAxiosInstance } from '../../../axiosInstances/axios';
import { ApplicationStatus } from '../../../types/applications';
import { AcademiaResponse } from '../../../types/common';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useApplicationStatusAction = (uuid: string) => {
  const getApplicationStatusHandler = useQuery({
    queryKey: ['application-status'],
    queryFn: async (): Promise<AcademiaResponse<ApplicationStatus>> => {
      const response = await getAxiosInstance('user').get(
        `/application/status/${uuid}/`
      );

      return response.data;
    },

    ...returnQueryConfig(!!uuid),
  });

  return { getApplicationStatusHandler };
};

export default useApplicationStatusAction;
